import SpinnerIcon from '@/components/icons/SpinnerIcon';

interface ProductListLoadingStateProps {
  label?: string;
}

const ProductListLoadingState = ({ label = 'Loading' }: ProductListLoadingStateProps) => (
  <div role="status" aria-live="polite" className="flex justify-center py-20">
    <SpinnerIcon />
    <span className="sr-only">{label}</span>
  </div>
);

export default ProductListLoadingState;
